export const stepsPercents = ['0%', '25%', '50%', '75%', '100%'];

export const defaultDarkColor = '#1c2b46';
export const defaultPrimaryColor = '#6576ff';
